// DefaultLocaleLayout — T-055. The unprefixed root route resets the locale to
// the stored/browser preference so that a visit to / after a shared /hu link
// does not stay in Hungarian.

import { useEffect } from "react";
import type { ReactElement } from "react";
import { Outlet } from "react-router-dom";
import { setLocale } from "../../i18n";
import { detectLocale } from "../../i18n/detectLocale";

export function DefaultLocaleLayout(): ReactElement {
  useEffect(() => {
    const l = detectLocale();
    setLocale(l);
    if (typeof document !== "undefined") {
      document.documentElement.lang = l;
    }
  }, []);

  return <Outlet />;
}
